import { GlobalToken, theme } from "antd";
import { CSSProperties, PropsWithChildren, ReactNode } from "react";
import { useScrollTop } from "src/hooks/useScrollTop";
import { CssVars } from "src/components/CssVars";

export const EntityScreen = (
  props: PropsWithChildren<{
    headerPanel: ReactNode;
    summaryPanel: ReactNode;
    insightsPanel: ReactNode;
  }>
) => {
  const { token } = theme.useToken();
  const [scrollRef, scrollTop] = useScrollTop();
  return (
    <CssVars>
      <div style={layoutStyle(token)}>
        <div style={mainStyle(token)}>
          {props.headerPanel}
          <div style={scrollStyle(token)}>
            {scrollTop > 4 && <div style={shadowStyle(token)} />}
            <div style={contentStyle(token)} ref={scrollRef}>
              <div style={{ width: "100%" }}>{props.summaryPanel}</div>
              <div style={{ width: "100%", flex: 1 }}>{props.children}</div>
            </div>
          </div>
        </div>
        {/* <div style={siderStyle(token)}>{props.insightsPanel}</div> */}
      </div>
    </CssVars>
  );
};

const layoutStyle: DynamicCss = (_) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  gap: 0,
});

const scrollStyle: DynamicCss = (_) => ({
  flex: 1,
  overflow: "hidden",
});

const mainStyle: DynamicCss = (_) => ({
  height: "100%",
  overflow: "auto",
  minWidth: 0,
  maxWidth: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  position: "relative",
});

const siderStyle: DynamicCss = (token) => ({
  height: "100%",
  overflow: "auto",
  borderLeft: `solid 1px ${token.colorBgBase}`,
});

const contentStyle: DynamicCss = (_) => ({
  height: "100%",
  overflow: "auto",
  overflowX: "hidden",
  padding: 16,
  display: "flex",
  flexDirection: "column",
});

const shadowStyle: DynamicCss = (token) => ({
  boxShadow: `inset 0 1px 1.5px ${token.colorBgBase}`,
  backgroundColor: "transparent",
  width: "100%",
  left: 0,
  height: 1,
  overflow: "visible",
});

type DynamicCss = (token: GlobalToken) => CSSProperties;
